import { DEFAULT_LOCALE, type Locale, isLocale } from '@silospot/shared';
import { create } from 'zustand';

const STORAGE_KEY = 'silospot-locale';

/** Best-matching supported locale from the browser's language list. */
function detectBrowserLocale(): Locale {
  if (typeof navigator === 'undefined') return DEFAULT_LOCALE;
  const langs = navigator.languages ?? [navigator.language];
  for (const lang of langs) {
    const code = lang?.slice(0, 2).toLowerCase();
    if (code && isLocale(code)) return code;
  }
  return DEFAULT_LOCALE;
}

/** Cached choice wins; otherwise fall back to the browser language (first login). */
function initialLocale(): Locale {
  if (typeof window === 'undefined') return DEFAULT_LOCALE;
  const stored = window.localStorage.getItem(STORAGE_KEY);
  return stored && isLocale(stored) ? stored : detectBrowserLocale();
}

interface LocaleState {
  locale: Locale;
  setLocale: (locale: Locale) => void;
}

export const useLocaleStore = create<LocaleState>((set) => ({
  locale: initialLocale(),
  setLocale: (locale) => {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(STORAGE_KEY, locale);
    }
    set({ locale });
  },
}));
